/*
 * @Author: 肖玲
 * @Date: 2023-03-01 10:31:57
 * @LastEditTime: 2023-03-01 15:55:27
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\butterfly-flow-system\flow-direction-intelligent-clean\modules\monthReportRouter.js
 * 月报
 */

// 和日报共用一套路由
const monthReportRouter = []
export default monthReportRouter
